import {RouteObject} from 'react-router';
import Form, {FormLoader} from '@/routes/form';
import Home from '@/routes/home';
import NotFound from '@/routes/not-found';
import FullNotFound from '@/routes/not-found/full-not-found';
import AllocationCreation from '@/routes/profile/allocation-creation';
import AllocationEdit, {AllocationLoader} from '@/routes/profile/allocation-edit';
import Profile from '@/routes/profile/profile';
import AppShell from './components/app-shell';
import {APP_PATH, ROOT_PATH} from './constants/routes';
import App, {AppLoader} from './routes/app';
import {revalidateOnAppPath} from './routes/app/loader';
import {CallbackLoader} from './routes/loader';
import Unavailable, {UnavailableLoader} from './routes/unavailable';

export type RouteHandle = {
  routeKey: string;
};

type RouteObjectWithHandle = RouteObject & {
  handle: RouteHandle;
};

type TypedHandleRouteObject = RouteObject & {
  children?: RouteObjectWithHandle[];
};

export const routes: TypedHandleRouteObject[] = [
  {
    path: APP_PATH,
    element: <App />,
    loader: AppLoader,
    shouldRevalidate: revalidateOnAppPath,
    children: [
      {
        index: true,
        element: <Home />,
        handle: {routeKey: 'accueil'},
      },
      {
        path: 'form/:formId',
        element: <Form />,
        loader: FormLoader,
        handle: {routeKey: 'document'},
      },
      {
        path: 'profile',
        element: <Profile />,
        handle: {routeKey: 'profile'},
      },
      {
        path: 'profile/allocations/create',
        element: <AllocationCreation />,
        handle: {routeKey: 'profile-creation-allocation'},
      },
      {
        path: 'profile/allocations/edit/:allocationId',
        element: <AllocationEdit />,
        loader: AllocationLoader,
        handle: {routeKey: 'profile-modification-allocation'},
      },
      {
        path: '*',
        element: <NotFound />,
        handle: {routeKey: 'non-disponible'},
      },
    ],
  },
  {
    path: '/unavailable',
    element: <Unavailable />,
    loader: UnavailableLoader,
    handle: {routeKey: 'non-disponible'},
  },
  {
    path: ROOT_PATH,
    element: <AppShell />,
    loader: CallbackLoader,
    handle: {routeKey: 'app-shell'},
  },
  {
    path: '*',
    element: <FullNotFound />,
    handle: {routeKey: 'non-trouve'},
  },
];
